'use client';

import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent, useState } from 'react';
import { ALLOWED_EXTENSIONS, MAX_FILE_SIZE } from '../constants/fileUpload';
export const useProfilePictureUpload = t0 => {
  const $ = _c(16);
  const {
    fileSizeErrorMessage,
    fileTypeErrorMessage,
    initialProfilePicture
  } = t0;
  const [previewPictureSource, setPreviewPictureSource] = useState(initialProfilePicture);
  let t1;
  if ($[0] !== initialProfilePicture) {
    t1 = event => {
      if (event && event.target?.files?.length) {
        const imageURL = URL.createObjectURL(event.target.files[0]);
        setPreviewPictureSource(imageURL);
        return;
      }
      setPreviewPictureSource(initialProfilePicture);
    };
    $[0] = initialProfilePicture;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updatePreviewPictureSource = t1;
  let t2;
  if ($[2] !== fileSizeErrorMessage) {
    t2 = fileList => {
      const isValidFileSize = fileList[0].size < MAX_FILE_SIZE;
      if (!isValidFileSize) {
        return {
          fileSizeErrorMessage: fileSizeErrorMessage ?? "The image is too big or empty.",
          isValidFileSize: false
        };
      }
      return {
        fileSizeErrorMessage: undefined,
        isValidFileSize: true
      };
    };
    $[2] = fileSizeErrorMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const validateFileSize = t2;
  let t3;
  if ($[4] !== fileTypeErrorMessage) {
    t3 = fileList_0 => {
      if (!fileList_0?.[0]) {
        return true;
      }
      const isValidFileExtension = ALLOWED_EXTENSIONS.includes(fileList_0[0]?.type?.split("/")?.pop() ?? "");
      return isValidFileExtension || (fileTypeErrorMessage ?? "Incorrect file format.");
    };
    $[4] = fileTypeErrorMessage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fileSizeErrorMessage) {
    t4 = fileList_1 => {
      if (!fileList_1?.[0]) {
        return true;
      }
      const isValidFileSize_0 = fileList_1[0]?.size < MAX_FILE_SIZE;
      return isValidFileSize_0 || (fileSizeErrorMessage ?? "The image is too big or empty.");
    };
    $[6] = fileSizeErrorMessage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      validate: {
        acceptedFormats: t3,
        lessThan5MB: t4
      }
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const rules = t5;
  let t6;
  if ($[11] !== previewPictureSource || $[12] !== rules || $[13] !== updatePreviewPictureSource || $[14] !== validateFileSize) {
    t6 = {
      previewPictureSource,
      rules,
      updatePreviewPictureSource,
      validateFileSize
    };
    $[11] = previewPictureSource;
    $[12] = rules;
    $[13] = updatePreviewPictureSource;
    $[14] = validateFileSize;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};